'use strict';


import resizeStore from '../resize/resize.store';
import {prefixedCSSValue} from 'a-utils';


class Creeping extends HTMLElement{
    constructor() {
        super();

        this._hide = this.dataset.hide;

        this._transform = this.dataset.noTransform || true;

        this._degree = this.dataset.degree;
        this._reverse = -1;

        this.onResize = () => this._onResize();
    }
    connectedCallback() {
        this._text = this.innerHTML;
        this.innerHTML = '';
        this._inner = document.createElement('div');
        this._class = this._degree < 0 ? '__reversed' : '__normal';
        this._inner.classList.add(this._class);
        this._inner.classList.add('creeping-inner');
        this._inner.classList.add('__paused');
        this._inner.innerHTML = this._text;

        if(this._transform === true) {
            this.style.transform = `rotate(${this._degree}deg) translate3d(0,0,0)`
        }

        this.appendChild(this._inner);

        let t = this._text.replace(' ', '');


        if (!this._inner.offsetWidth && !this._inner.offsetHeight || !t) {
         //   console.warn('Нет контента в ', this);
            this.style.visibility = 'hidden';
            return;
        }

        this._lines = [];
        this._itemsCount = 0;


        this._onResize();
        resizeStore.eventEmitter.addListener(this.onResize);
    }
    disconnectedCallback() {

       // cancelAnimationFrame(this._raf);
        resizeStore.eventEmitter.removeListener(this.onResize);
    }

    _onResize() {
        let vw = resizeStore.getData().width;
        const w = this.offsetWidth;
        const wi = this._inner.offsetWidth;

        if (this._hide) {
            if (vw < this._hide) {
                this.style.display = 'none'
                return;
            }
            if (vw > this._hide) {
                this.style.display = ''
            }

        }

        const countW = Math.ceil(w / wi) + 2;
        const countH = 1;

        if (countH > this._lines.length) {
            const size = countH - this._lines.length;

            for (let i = 0; size > i; i ++) {
                const elem = this;
                this._lines.push({
                    elem,
                    enabled: true,
                    inners: [],
                    reverse: this._reverse
                });

                this._reverse *= -1;
            }
        } else {
            this._lines.forEach((line, index) => (line.enabled = index < countH));
        }

        if (countW > this._itemsCount) {
            const size = countW - this._itemsCount;

            this._lines.forEach(line => {
                for (let i = 0; i < size; i++) {
                    const clone = this._inner.cloneNode(true);
                    line.inners.push(clone);
                    line.elem.appendChild(clone);
                }
            })
            this._itemsCount = countW;
        }
    }
}

window.customElements.define('creeping-line', Creeping);
